<ngx-spinner bdColor="rgba(0,0,0, 0.8)" color="white" [fullScreen]="true" type="null" size="small">
    <img style="width:90px" src='../assets/imgs/pandora-loading.gif' />
</ngx-spinner>
<router-outlet></router-outlet>
<app-footer></app-footer>